import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { List } from 'immutable';
import { IToastData } from './toast.data';
import { WindowRefService } from 'i2g-ng-utils';

// exported interface
export interface IToastOptions {
  timeout?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private _toastsData = new BehaviorSubject<List<IToastData>>(
    List<IToastData>([])
  );

  /**
   * Default delay before dismissing the toast
   */
  private _defaultTimeout = 5;

  toasts$: Observable<List<IToastData>> = this._toastsData.asObservable();

  constructor(private _windowRefService: WindowRefService) {}

  show(message: string, toastOptions: IToastOptions = {}) {
    this._toastsData.next(
      List<IToastData>(
        this._toastsData.value
          .push({
            id: this._randomId(),
            message,
            timeout: toastOptions.timeout || this._defaultTimeout,
          })
          .toList()
      )
    );
  }

  popById(id: string) {
    this._toastsData.next(
      this._toastsData.value.filter((item) => item.id !== id).toList()
    );
  }

  clearAll() {
    this._toastsData.next(List<IToastData>([]));
  }

  private _randomId(): string {
    // try to use crypto, else fallback to unix timestamp
    try {
      const uint32 = this._windowRefService.nativeWindow.crypto.getRandomValues(
        new Uint32Array(1)
      )[0];
      return uint32.toString(16);
    } catch (e) {
      return this._windowRefService.nativeWindow.Date.now();
    }
  }
}
